import * as React from 'react';
import AddFeedForm from './parts/AddFeedForm'
import {ExportFeed} from './parts/ExportFeed'
import {FeedList} from './parts/FeedList'
import {FeedItem, NewIcalFeed, Feed} from './types'
import {List, Map } from 'immutable'
import * as Api from './api'
import * as DL from '../../utils/datalayer'


declare var I18n : {
  locale: string,
  t: (_:string, __?: any) => string,
  toCurrency:(_:number) => string
}

export interface IcalFeedsManagerProps {
  base_url:string,
  rental_id:string,
  room_id:string,
  export_url:string
  title:string
};

export interface IcalFeedsManagerState {
  loading:boolean
  creating:boolean
  feeds:List<FeedItem>
  errors: Map<string, List<string>>
};

class IcalFeedsManager extends React.Component<IcalFeedsManagerProps, IcalFeedsManagerState> {

  constructor(props:IcalFeedsManagerProps) {
    super(props);
    this.state = {
      loading:true,
      creating:false,
      feeds: List<FeedItem>([]),
      errors: Map<string, List<string>>(),
    }
  }

  componentDidMount() {
    this.loadFeeds();
  }

  async loadFeeds() {
    const result = await Api.getFeeds(this.props)
    let feedItems = List<Feed>(result).map((f) => {
      return { feed: f, status: 'idle'} as FeedItem
    }).toList();
    this.setState({...this.state, loading: false, feeds: feedItems })
  }

  addFeed = (feed:NewIcalFeed, success: () => void) => {
    this.setState({...this.state, creating: true}, async () => {
      const result = await Api.createFeed(this.props, feed)
      if(result.success) {
        DL.push({ event: "iCal.Calendar", category: "iCal", action: "button click", label: "add calendar" });

        this.setState({
          ...this.state,
          creating: false,
          feeds: this.state.feeds.push({ feed: result.feed, status: "idle"}),
          errors: Map<string, List<string>>(),
        }, () => {
          this.syncFeed(result.feed)
        });
        success()
      } else {
        this.setState({...this.state, creating: false, errors: Map<string, List<string>>(result.messages)})
      }
    })
  }

  removeFeed = (feed:Feed) => {
    this.setState({
      ...this.state,
      feeds: this.state.feeds.filter(i => i.feed.id !== feed.id).toList()
    }, async () => {
      await Api.removeFeed(this.props, feed)
      DL.push({ event: "iCal.Calendar", category: "iCal", action: "button click", label: "remove calendar" });
    })
  }

  updateFeed = (item:FeedItem, cb:() => void) => {
    this.setState({
      ...this.state,
      feeds: this.state.feeds.map(i => {
        if(i.feed.id === item.feed.id) return item
        else return i;
      }).toList()
    }, cb)
  }

  syncFeed = (feed:Feed) => {
    this.updateFeed({feed: { ...feed }, status: "syncing"}, async () => {
      const res = await Api.syncFeed(this.props, feed)
      if (res.status == 'ok') {
        DL.push({ event: "iCal.Calendar", category: "iCal", action: "button click", label: "sync calendar" });
        this.updateFeed({feed: {...feed, ...res.feed}, status:  "idle" }, () => null)
      } else {
        this.updateFeed({feed: feed, status: "error", error: res.error }, () => null)
      }
    });
  }

  public render(): JSX.Element {
    return (
      <div className="Ical ical-feed">
        <h2>{this.props.title}</h2>
        <p className="Ical_text" dangerouslySetInnerHTML={{__html: I18n.t("calendar_feeds.crud.intro")}} />
        <AddFeedForm
          addFeed={this.addFeed}
          creating={this.state.creating}
          errors={this.state.errors}
        />
        <FeedList
          feeds={this.state.feeds.sortBy(x => x.feed.name).toArray()}
          removeFeed={this.removeFeed}
          syncFeed={this.syncFeed}
        />
        <ExportFeed
          url={this.props.export_url}
          onCopy={() => DL.push({ event: "iCal.Calendar", category: "iCal", action: "button click", label: "copy url" })}
        />
      </div>
    );
  }
}

export default IcalFeedsManager;
